import {
    batchRegulationsReceived,
    getBatchRegulations,
    getDeleteBatchRegulations,
    getSelectedParkingRateBatchData,
    proposedParkingBatchRegulationsReceived,
    setSelectedBatchIds,
    toggleBatchActionPerformed
} from "actions";
import {
    DELETE_BATCH_REGULATION,
    DeleteBatchRegulationAction,
    GET_BATCH_REGULATIONS,
    GET_DELETE_BATCH_REGULATIONS,
    ToggleBatchActionPerformedAction,
    batchRegulationsReceivedAction,
    getBatchRegulationsAction,
    getDeleteBatchRegulationAction,
    setSelectedBatchIdsAction
} from "actions/regulation/BatchSelection/types";
import axios from "axios";
import { showError } from "components/commonUtilities";
import { PutEffect, SelectEffect, put, select, takeLatest } from "redux-saga/effects";
import {
    GET_SELECTED_PARKING_RATE_BATCH_DATA,
    GetSelectedParkingRateBatchData,
    ProposedParkingBatchRegulationsReceivedAction,
    ProposedParkingRateRegulationsRecords
} from "../actions/regulation/EditParkingRates/types";
import { ProposedRegulationReceived } from "../actions/regulation/types";
import { RootState } from "reducers";
import { GeneratorYieldType } from "interfaces/ActionReducer/GetMethod/GetResponse";

const showParkingBatchListView = (state: RootState) =>
    state.editParkingRates.showParkingBatchListView;

function* getBatchRegulationsFunc(
    action: getBatchRegulationsAction
): Generator<
    | Promise<setSelectedBatchIdsAction>
    | Promise<ProposedParkingBatchRegulationsReceivedAction>
    | Promise<batchRegulationsReceivedAction>
    | PutEffect<{ payload: setSelectedBatchIdsAction["payload"]; type: string }>
    | PutEffect<{ payload: ProposedParkingBatchRegulationsReceivedAction["payload"]; type: string }>
    | PutEffect<{ payload: batchRegulationsReceivedAction["payload"]; type: string }>,
    void,
    ProposedParkingRateRegulationsRecords | ProposedRegulationReceived
> {
    if (action.payload?.params) {
        let url = "/api/proposed_regulation/?";

        Object.keys(action.payload.params).forEach((prop: string) => {
            if (action.payload?.params && Array.isArray(action.payload.params[prop])) {
                let allFilters = action.payload.params[prop].toString();
                url += `&${prop}=${allFilters}`;
            } else {
                if (prop !== "limit" && prop !== "offset") {
                    action.payload?.params && (url += `&${prop}=${action.payload.params[prop]}`);
                }
            }
        });
        try {
            const json = yield axios.get(url).then((response) => response.data);

            const data = json.results[0];

            json.results[0]?.proposedregulationlinks_set.map((i: any) => {
                i.action = data.action || "Revision";
                i.regulationId = data.regulationId;
                i.sub_activity = data.sub_activity;
                i.created = json.results[0].created;
                i.published_on = data.published_on;
                i.user = data.user;
                i.proposedId = data.id;
            });
            const final = json.results[0]?.proposedregulationlinks_set.slice(0, 10);
            yield put(
                setSelectedBatchIds({
                    selectedBatchData: json.results[0]?.proposedregulationlinks_set
                })
            );

            yield put(
                batchRegulationsReceived({
                    data: final
                })
            );
        } catch (error) {
            showError(error);
        }
    }
}

export function* getBatchRegualationSaga() {
    yield takeLatest(GET_BATCH_REGULATIONS, getBatchRegulationsFunc);
}

function* getDelteBatchRegulationsFunc(
    action: getDeleteBatchRegulationAction
): Generator<
    | Promise<setSelectedBatchIdsAction>
    | Promise<batchRegulationsReceivedAction>
    | PutEffect<{ payload: batchRegulationsReceivedAction["payload"]; type: string }>
    | PutEffect<{ payload: setSelectedBatchIdsAction["payload"]; type: string }>
> {
    try {
        let url = "/api/proposedregulationlinks/?";
        Object.keys(action.payload.params).forEach((prop: string) => {
            if (action.payload?.params && Array.isArray(action.payload.params[prop])) {
                let allFilters = action.payload.params[prop].toString();
                url += `&${prop}=${allFilters}`;
            } else {
                if (prop !== "limit" && prop !== "offset") {
                    action.payload?.params && (url += `&${prop}=${action.payload.params[prop]}`);
                }
            }
        });
        const json: any = yield axios.get(url).then((res) => res.data);
        json.results.map((i: any) => {
            i.action = i.regulation.action;
            i.regulationId = i.regulation.regulationId;
            i.sub_activity = i.regulation.sub_activity;
            i.published_on = i.regulation.published_on;
            i.user = i.regulation.user;
            i.proposedId = i.regulation.id;
        });
        yield put(
            setSelectedBatchIds({
                selectedBatchData: json.results
            })
        );
        yield put(
            batchRegulationsReceived({
                data: json.results.slice(0, 10)
            })
        );
    } catch (error) {
        showError(error);
    }
}

export function* getDeleteBatchRegualationSaga() {
    yield takeLatest(GET_DELETE_BATCH_REGULATIONS, getDelteBatchRegulationsFunc);
}

function* deleteBatchRegulation(
    action: DeleteBatchRegulationAction
): Generator<
    | Promise<
          | ToggleBatchActionPerformedAction
          | getDeleteBatchRegulationAction
          | GetSelectedParkingRateBatchData
          | getBatchRegulationsAction
      >
    | SelectEffect
    | GeneratorYieldType<ToggleBatchActionPerformedAction>
    | GeneratorYieldType<getDeleteBatchRegulationAction["payload"]>
    | GeneratorYieldType<GetSelectedParkingRateBatchData["payload"]>
    | GeneratorYieldType<getBatchRegulationsAction["payload"]>,
    void,
    any
> {
    try {
        const dataToSend = {
            proposed_regulation_link_ids: action.payload.ids
        };
        yield axios.request({
            method: "delete",
            url: "/api/proposedregulationlinks/delete_proposed_regulation_links/",
            data: dataToSend
        });
        yield put(toggleBatchActionPerformed());
        if (action.payload.afterDelete) {
            action.payload.afterDelete();
        }
        if (action.payload.params) {
            if (Object.keys(action.payload.params).includes("batch__id__in")) {
                yield put(getDeleteBatchRegulations({ params: action.payload.params }));
            } else {
                const shouldShowParkingBatchListView = yield select(showParkingBatchListView);
                if (shouldShowParkingBatchListView) {
                    yield put(
                        getSelectedParkingRateBatchData({ params: action.payload.params as any })
                    );
                } else {
                    yield put(getBatchRegulations({ params: action.payload.params }));
                }
            }
        }
    } catch (error) {
        showError(error);
    }
}

export function* deleteBatchRegulationSaga() {
    yield takeLatest(DELETE_BATCH_REGULATION, deleteBatchRegulation);
}

function* getSelectedParkingRateBatchDataFunc(
    action: GetSelectedParkingRateBatchData
): Generator<
    | Promise<ProposedParkingBatchRegulationsReceivedAction>
    | GeneratorYieldType<ProposedParkingBatchRegulationsReceivedAction["payload"]>
> {
    try {
        const json: any = yield axios
            .get("/api/proposedregulationlinks/get_batch_proposed_regualtion_links/", {
                params: action.payload.params
            })
            .then((res) => res.data);
        json.results.map((i: any) => {
            i.action = i.action ?? "Revision";
            i.regulationId = i.proposed_regulation.regulationId;
            i.sub_activity = i.proposed_regulation.sub_activity;
            i.created = i.created;
            i.published_on = i.published_on;
            i.proposedId = i.proposed_regulation.id;
            i.user = i.user;
            i.curb_link = i.curb_link;
            i.batch_id = i.batch.id;
        });
        yield put(
            proposedParkingBatchRegulationsReceived({
                proposedParkingRateBatchRegulations: {
                    ...json
                }
            })
        );
    } catch (err) {
        showError(err);
    }
}

export function* getSelectedParkingRateBatchDataSaga() {
    yield takeLatest(GET_SELECTED_PARKING_RATE_BATCH_DATA, getSelectedParkingRateBatchDataFunc);
}
